
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./useHostAuthState": () => {
return Promise.all(/*  | __federation_expose_useHostAuthState */ [__webpack_require__.e("983"), __webpack_require__.e("577")]).then(() => (() => (__webpack_require__(18025))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };